import * as React from 'react';
import Grid from '@mui/material/Grid';
import Card from '@mui/material/Card';
import Typography from '../../../layouts/theme-onboarding/Typography';
import Color from '../../../layouts/Color';

const cardData = { maxWidth: 345, maxHeight: 500, height: 395, mt: 2 };
const cardNoData = { maxWidth: 345, maxHeight: 500, height: 395, mt: 2 };
const overFlow = { overflowWrap: 'break-word' }
const paddingGrid = { padding: 2 };

export default function BackCardData(props) {

  const renderBackCardData = (data) => {
    return data ? (
      <Card sx={cardData}>
        <Grid container spacing={3} sx={paddingGrid}>
          <Grid item xs={12} sm={4}>
            <Typography variant="body3" color={Color.Normal}> Features: </Typography>
          </Grid>
          <Grid item xs={12} sm={8}>
            <Typography variant="body3" color={Color.Normal}> {data.features} </Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography variant="body3" color={Color.Normal}> Issue: </Typography>
          </Grid>
          <Grid item xs={12} sm={8}>
            <Typography variant="body3" color={Color.Normal}> {data.issue_date} </Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography variant="body3" color={Color.Normal}> Mrz: </Typography>
          </Grid>
          <Grid item xs={12} sm={8} style={overFlow}>
            <Typography variant="body3" color={Color.Normal}> {data.mrz} </Typography>
          </Grid>
          <Grid item xs={12} sm={4}>
            <Typography variant="body3" color={Color.Normal}> Location: </Typography>
          </Grid>
          <Grid item xs={12} sm={8}>
            <Typography variant="body3" color={Color.Normal}> {data.issue_loc} </Typography>
          </Grid>
        </Grid>
      </Card>
    ) : (
      <Card sx={cardNoData}>
      
      </Card>
    );
  }

  return (
    <React.Fragment>
      {renderBackCardData(props.eKycBackResponse)}
    </React.Fragment>
  );
}